export default __webpack_public_path__ + "media/financial-cents-logo.863a6.png";